<div class="contenedorComponenteCon">
  @if(header){
    <div class="headerComponenteCon">
      <div class="infoComponenteCon" #info [matTooltip]="value" [appOverflowTooltip]="value">
          <div class="tituloComponenteCon" #titulo>
            {{header.title}}
          </div>
          @if (header.subtitles?.length) {
            <div class="subtitlesComponenteCon">
              @for (sub of header.subtitles; track $index) {
                <span>
                  @if (sub.icon) {
                    <mat-icon>{{sub.icon}}</mat-icon>
                  }
                  &bull;
                  {{sub.text}}
                </span>
              }
            </div>
          }
          @if (header.chips?.length) {
            <div class="chipsComponenteCon" appChipsFit>
              @for (chip of header.chips; track $index) {
                <div class="chipComponenteCon" [class]="chip.color ?? 'primary'">
                  {{chip.text}}
                </div>
              }
            </div>
          }
      </div>
      <div class="actionsComponenteCon">
        <ng-content select="[iconos]">
        </ng-content>
      </div>
    </div>
  }
  <div class="bodyComponenteCon">
    <ng-content select="[body]">
    </ng-content>
  </div>
</div>
